import { connect } from 'react-redux';
import { IState } from '../../reducers';
import { fetchWelcomePageHighlightMainItemsAction, fetchWelcomePageHighlightSubMainItemsAction } from './actions/fetchWelcomePageHighlightMainItems';

import {WelcomePageMainHighlight} from './welcomePageHighlight';

const mapStateToProps = (state: IState) => ({
    mainHighlightItems: state.welcomePageContent.mainHighlightItems,
    subMainHighlightItems: state.welcomePageContent.subMainHighlightItems,
});

const mapDispatchToProps = (dispatch: any) => ({
    fetchWelcomePageHighlightMainItems: () => dispatch(fetchWelcomePageHighlightMainItemsAction()),
    fetchWelcomePageHighlightSubMainItems: () => dispatch(fetchWelcomePageHighlightSubMainItemsAction())
});

export const WelcomePageHighlightContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(WelcomePageMainHighlight);


// WEBPACK FOOTER //
// ./src/components/welcomePageHighlight/welcomePageHighlightContainer.tsx